import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import {
	slowQueryGuard,
	SLOW_QUERY_DEFAULT_TIMEOUT,
} from '@confluence/query-preloader-tools/entry-points/slowQueryGuard.ts';

import {
	preloadIncomingLinksSample,
	type IncomingLinksSampleResult,
} from './preloadIncomingLinksSample.ts';

type IncomingLinksSampleMeasurementRoute = 'view';

type PreloadIncomingLinksSampleForMeasurementArgs = Readonly<{
	cloudId: string;
	contentId: string;
	route: IncomingLinksSampleMeasurementRoute;
}>;

const INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE = 'ssr-app/prepare/incomingLinksSample';

const recordIncomingLinksSampleOutcome = (
	result: IncomingLinksSampleResult,
	route: IncomingLinksSampleMeasurementRoute,
): void => {
	const outcome =
		result.status === 'unavailable'
			? result.reason
			: result.sourceAris.length === 0
				? 'empty'
				: result.sourceAris.length >= 3
					? 'limit-reached'
					: 'one-or-two';

	SSRMeasures.addMeasure(`${INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE}/${route}/outcome:${outcome}`, 0);
};

export const preloadIncomingLinksSampleForMeasurement = async ({
	cloudId,
	contentId,
	route,
}: PreloadIncomingLinksSampleForMeasurementArgs): Promise<void> => {
	let samplePromise: Promise<IncomingLinksSampleResult> | undefined;
	const getSample = (): Promise<IncomingLinksSampleResult> => {
		samplePromise ??= preloadIncomingLinksSample({ cloudId, contentId });
		return samplePromise;
	};
	const completedWithinGuard = await slowQueryGuard(
		'preloadIncomingLinksSample',
		async () => {
			await getSample();
		},
		SLOW_QUERY_DEFAULT_TIMEOUT,
	);

	if (!completedWithinGuard) {
		SSRMeasures.addMeasure(`${INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE}/${route}/outcome:timeout`, 0);
		return;
	}

	recordIncomingLinksSampleOutcome(await getSample(), route);
};
